import { render, staticRenderFns } from "./DetailTransaksiGadai.vue?vue&type=template&id=a18e0724&scoped=true&"
import script from "./DetailTransaksiGadai.vue?vue&type=script&lang=js&"
export * from "./DetailTransaksiGadai.vue?vue&type=script&lang=js&"
import style0 from "./DetailTransaksiGadai.vue?vue&type=style&index=0&id=a18e0724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18e0724",
  null
  
)

export default component.exports